export default __webpack_public_path__ + "static/media/480_business02-it-web.9330ac76.png";